import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { FeesSection, CorrespondentOnlySection, DynamicFee } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

export interface ServicesCannotShopFormData {
  appraisalFee: number;
  creditReport: number;
  dynamicFees: DynamicFee[];
}

@Component({
  selector: 'services-cannot-shop',
  templateUrl: './services-cannot-shop.component.html',
  styleUrls: ['./services-cannot-shop.component.scss'],
  standalone: false
})
export class ServicesCannotShopComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('servicesCannotShopForm') servicesCannotShopForm: NgForm;

  @Input() fees: FeesSection | undefined;
  @Input() correspondentOnly: CorrespondentOnlySection | undefined;

  formData: ServicesCannotShopFormData = {
    appraisalFee: null,
    creditReport: null,
    dynamicFees: []
  };

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fees'] || changes['correspondentOnly']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.servicesCannotShopForm) {
      this.servicesCannotShopForm.form.markAllAsTouched();
      return this.servicesCannotShopForm.form.valid;
    }
    return true;
  }

  getFormData(): ServicesCannotShopFormData {
    return {
      ...this.formData,
      dynamicFees: [...this.formData.dynamicFees]
    };
  }

  addDynamicFee(): void {
    this.formData.dynamicFees.push({ uuid: crypto.randomUUID(), name: '', amount: null });
  }

  removeDynamicFee(index: number): void {
    this.formData.dynamicFees.splice(index, 1);
  }

  private populateFormFromApiData(): void {
    if (this.fees) {
      this.formData.appraisalFee = this.fees.appraisalFee || null;
      this.formData.creditReport = this.fees.creditReportFee || null;
      this.formData.dynamicFees = this.fees.dynamicServicesCannotShop?.map(fee => ({
        ...fee,
        uuid: fee.uuid || crypto.randomUUID()
      })) || [];
    }
  }
}
